import { PickupLocationPicker } from './PickupLocationPicker'

const PickupFulfillment = ({ fulfillment, onChangeDate, onChangeLocation, pickupLocations }) => {
  return (
    <div className="shippingFulfillment">
      <div>
        <PickupLocationPicker fulfillment={fulfillment} onChangeDate={onChangeDate} onChangeLocation={onChangeLocation} pickupLocations={pickupLocations} />
      </div>
    </div>
  )
}
export { PickupFulfillment }
